import classNames from "classnames";
import type { CSSProperties } from "react";

import type { V2UnitDef } from "../../../types";
import { normalizeUnit } from "../../../utils/normalizeUnit";
import styles from "./Unit.module.scss";

interface UnitProps {
  unit: V2UnitDef;
}

/**
 * Render unit suffix or unit box next to an input.
 * @param unit - Unit definition to render\n * @returns JSX element
 */
export function Unit({ unit }: UnitProps) {
  const { text, unitWidth, unitStyle } = normalizeUnit(unit);

  if (!text) return null;

  const inlineStyle: CSSProperties = {
    ...(unitWidth && { width: unitWidth, flexShrink: 0 }),
  };

  const unitClassName = classNames(
    styles.unit,
    unitStyle === "inset-solid" && styles.insetSolid,
    unitStyle === "blank" && styles.blank,
  );

  return (
    <span className={unitClassName} style={inlineStyle}>
      {text}
    </span>
  );
}
